import SekuritiesPage from './sekurities-page';

export default SekuritiesPage;